import React from 'react';
import './DronePhotographyHeader.css';

const DronePhotographyHeader = ({ content = {} }) => (
  <section
    className="drone-photography"
    style={{ backgroundImage: `url(${process.env.PUBLIC_URL}${content.heroImage || '/drone-photography.jpg'})` }}
  >
    <div className="drone-photography__overlay"></div>

    <div className="drone-photography__content">
      <h1>{content.title || 'Drone Photography'}</h1>
      <div className="drone-photography__underline"></div>
    </div>
  </section>
);

export default DronePhotographyHeader;

